module.exports = __webpack_public_path__ + "img/transfer.fa459b5f.png";